const defaultGeneralOption = {
  month: 'long',
  day: 'numeric',
  year: 'numeric'
} as Intl.DateTimeFormatOptions

export const currencyFormat = (val: number): string => {
  const formattedValue = new Intl.NumberFormat('id-ID', {currency: 'IDR'}).format(val)
  return `Rp. ${formattedValue}`
}

export const serializeQueryParam = (paramObj) => {
  if (paramObj) {
    return `?${Object.keys(paramObj).map(k => {
      if (paramObj[k] && typeof paramObj[k] === 'object') {
        return paramObj[k].map(v => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join('&')
      }
      if (paramObj[k]) return `${encodeURIComponent(k)}=${encodeURIComponent(paramObj[k])}`
      return `${encodeURIComponent(k)}=`
    }).join('&')}`
  }
  return ''
}

export const hourFormat = (value: number) => `${(`0${value}`).slice(-2)}:00`

export const getDateTimeInputString = (date: Date) => {
  const dateString = date.toISOString()
  return dateString.split('.')[0]
}

export const getShortDateFormat = (timestamp: number, locale: string = 'en-US', generalOption: Intl.DateTimeFormatOptions = defaultGeneralOption) =>
  new Date(timestamp).toLocaleString(locale, {
    timeZone: 'Asia/Makassar',
    ...generalOption
  })

export const getLongDateFormat = (timestamp: number, locale: string = 'en-US', generalOption: Intl.DateTimeFormatOptions  = defaultGeneralOption) =>
  new Date(timestamp).toLocaleDateString(locale, {
    timeZone: 'Asia/Makassar',
    ...generalOption
  })

export const transformDateTimeInputStringToTimestamp = (dateTimeString: string) => {
  const timeZone = new Date().toISOString().split('.')[1]
  return new Date(`${dateTimeString}.${timeZone}`).getTime()
}

export const checkWeekday = (date) => {
  const day = new Date(date).getDay()
  return (day === 0 || day === 6) ? 'WEEKEND' : 'WEEKDAYS'
}

export const formatCapitalWords = (text: string) =>
  text.toLowerCase().replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());

export const generateRandomColors = () => Math.floor(Math.random()*16777215).toString(16);

export const addDays = (timestamp, days) => {
  const multiplier = 24 * 60 * 60 * 1000
  return timestamp + (days * multiplier)
}

// To display data
export const convertToLocalTime = (witaTimestamp) : number => {
  const dateInPlus8 = new Date(witaTimestamp);
  const localOffset = dateInPlus8.getTimezoneOffset();
  const plus8Offset = -480; // -8 hours * 60 minutes
  let offsetDifference = localOffset - plus8Offset;
  if (plus8Offset > localOffset) {
    offsetDifference = -offsetDifference
  }
  const localDate = new Date(dateInPlus8.getTime() + offsetDifference * 60000);
  return localDate.getTime();
}

// To send data
export const convertLocalToWita = (localTimestamp) : number => {
  const localDate = new Date(localTimestamp);
  const localOffset = localDate.getTimezoneOffset();
  const plus8Offset = -480; // -8 hours * 60 minutes
  let offsetDifference = localOffset - plus8Offset;
  if (plus8Offset < localOffset) {
    offsetDifference = -offsetDifference
  }
  const dateInPlus8 = new Date(localDate.getTime() + offsetDifference * 60000);
  return dateInPlus8.getTime();
}

export const normalizeTimestampTime = (timestamp: number): number => {
  const date = new Date(timestamp);
  date.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to zero.
  return date.getTime();
}

export const isYesterday = (timestamp: number) : boolean => {
  const currentDate = new Date(timestamp)
  const yesterdayDate = new Date()
  yesterdayDate.setDate((yesterdayDate.getDate()) - 1)

  return currentDate.getDate() === yesterdayDate.getDate() &&
    currentDate.getMonth() === yesterdayDate.getMonth() &&
    currentDate.getFullYear() === yesterdayDate.getFullYear()
}

export const normalizeText = (text: string) : string =>
  text.toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())

export const getFileSize = (bytes, decimals = 2) => {
    if (!+bytes) return '0 Bytes';
  
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  
    const i = Math.floor(Math.log(bytes) / Math.log(k));
  
    return `${parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`;
  };


  export const disableHandleOnWheel = (e) => {
      e.target.blur()
      e.stopPropagation()
  };
  

  export const groupBookingHours = (
    hours: number[]
  ): { [key: string]: { start: number; end: number; duration: number } } => {
    const bookedHours = {};
    hours.sort((a, b) => a - b);
    let start = 0;
    let end = 0;
    let duration = 0;
    hours.forEach((hour) => {
      if (hour === end) {
        end += 1;
        duration += 1;
        bookedHours[start].end = end;
        bookedHours[start].duration = duration;
      } else {
        start = hour;
        end = hour + 1;
        duration = 1;
        bookedHours[start] = {
          start,
          end,
          duration,
        };
      }
    });
    return bookedHours;
  };